export const priorityList = [
  { name: 'Low', value: 'LOW' },
  { name: 'Medium', value: 'MEDIUM'},
  { name: 'High', value: 'HIGH' },
  { name: 'Critical', value: 'CRITICAL' },
]
